<div class="cal-week-view" [style.height.px]="CalendarHeight" role="grid">
    <div class="cal-day-headers" role="row" [style.margin-right.px]="detectMargin()">
        @for (user of users; track trackByUserId($index, user)) {
        <div class="cal-header" tabindex="0" role="columnheader">
            <b>{{ user.name }}</b>
            @if (!user.reducedMode) {
            <div class="row">
                <div class="col-3 text-center fw-bold">
                    <span style="vertical-align: super">{{user.pumpWithBattery ?? 0}}</span>
                    <mat-icon class="material-symbols-outlined"> battery_charging_full </mat-icon>
                </div>
                <div class="col-3 text-center fw-bold">
                    <span style="vertical-align: super">{{user.pumpWithoutBattery ?? 0}}</span>
                    <mat-icon class="material-symbols-outlined"> power </mat-icon>
                </div>
                <div class="col-3 text-center fw-bold">
                    <span style="vertical-align: super">{{user.fan ?? 0}}</span>
                    <mat-icon class="material-symbols-outlined"> wind_power </mat-icon>
                </div>
                <div class="col-3 text-center fw-bold">
                    <span style="vertical-align: super">{{user.processMeasure ?? 0}} </span>
                    <mat-icon class="material-symbols-outlined"> vignette </mat-icon>
                </div>
            </div>
            }
            @if (!user.reducedMode) {
            <div class="row">
                <div class="col-3 text-center fw-bold">
                    <span style="vertical-align: super">{{user.dpumpWithBattery ?? 0}}</span>
                    <mat-icon class="material-symbols-outlined" color="accent"> battery_charging_full </mat-icon>
                </div>
                <div class="col-3 text-center fw-bold">
                    <span style="vertical-align: super">{{user.dpumpWithoutBattery ?? 0}}</span>
                    <mat-icon class="material-symbols-outlined" color="accent"> power </mat-icon>
                </div>
                <div class="col-3 text-center fw-bold">
                    <span style="vertical-align: super">{{user.dfan ?? 0}}</span>
                    <mat-icon class="material-symbols-outlined" color="accent"> wind_power </mat-icon>
                </div>
                <div class="col-3 text-center fw-bold">
                    <!-- <span style="vertical-align: super">{{user.dprocessMeasure ?? 0}} </span>
              <mat-icon class="material-symbols-outlined" color="accent"> vignette </mat-icon> -->
                </div>
            </div>
            }
            @if (IsDispatch && !user.reducedMode) {
            <div class="row px-3  text-center">
                <div class="col-6">
                    <button class="justify-content-end" style="height: 24px;" color="warn" mat-raised-button (click)="cleanSamplerDay(user)">
                        <mat-icon class="material-symbols-outlined">delete</mat-icon>
                    </button>
                </div>
                <div class="col-6">
                    <button class="justify-content-end" style="height: 24px;" color="accent" mat-raised-button (click)="sendMail(user)">
                        <mat-icon class="material-symbols-outlined">outgoing_mail</mat-icon>
                    </button>
                </div>
            </div>
            }
        </div>
        }
    </div>
    @if (view.allDayEventRows.length > 0) {
    <div class="cal-all-day-events" #allDayEventsContainer mwlDroppable (dragEnter)="dragEnter('allDay')" (dragLeave)="dragLeave('allDay')" [draggable]="IsDispatch">
        <div class="cal-day-columns">
            <div class="cal-time-label-column" [ngTemplateOutlet]="allDayEventsLabelTemplate"> </div>
            @for (day of days; track day.date.toISOString()) {
            <div class="cal-day-column" mwlDroppable dragOverClass="cal-drag-over" (drop)="eventDropped($event, day.date, true)"
                 (dragEnter)="dateDragEnter(day.date)"> </div>
            }
        </div>
        @for (eventRow of view.allDayEventRows; track eventRow.id) {
        <div #eventRowContainer class="cal-events-row">
            @for (allDayEvent of eventRow.row; track allDayEvent.event.id ?? allDayEvent.event) {
            <div #event class="cal-event-container" [class.cal-draggable]="allDayEvent.event.draggable && allDayEventResizes.size === 0"
                 [class.cal-starts-within-week]="!allDayEvent.startsBeforeWeek" [class.cal-ends-within-week]="!allDayEvent.endsAfterWeek"
                 [ngClass]="allDayEvent.event.cssClass" [style.width.%]="(100 / users.length) * allDayEvent.span"
                 [style.marginLeft.%]="(100 / users.length) * allDayEvent.offset" mwlDraggable dragActiveClass="cal-drag-active"
                 [dropData]="{ event: allDayEvent.event, calendarId: calendarId }" [dragAxis]="{
                    x: (allDayEvent.event.draggable && allDayEventResizes.size === 0) ?? false,
                    y: (!snapDraggedEvents && allDayEvent.event.draggable && allDayEventResizes.size === 0) ?? false}"
                 [dragSnapGrid]="snapDraggedEvents ? { x: dayColumnWidth } : {}" [validateDrag]="validateDrag"
                 (dragStart)="dragStarted(eventRowContainer, event, allDayEvent, false)" (dragging)="allDayEventDragMove()"
                 (dragEnd)="dragEnded(allDayEvent, $event, dayColumnWidth)">
                <mwl-calendar-week-view-event [locale]="locale" [weekEvent]="allDayEvent" [tooltipPlacement]="tooltipPlacement"
                                              [tooltipTemplate]="tooltipTemplate" [tooltipAppendToBody]="tooltipAppendToBody" [tooltipDelay]="tooltipDelay"
                                              [customTemplate]="eventTemplate" [eventTitleTemplate]="eventTitleTemplate" [eventActionsTemplate]="eventActionsTemplate"
                                              [daysInWeek]="daysInWeek" (eventClicked)="eventClicked.emit({event: allDayEvent.event, sourceEvent: $event.sourceEvent})">
                </mwl-calendar-week-view-event>
            </div>
            }
        </div>
        }
    </div>
    }
    <div class="cal-time-events" [style.height.px]="CalendarWithoutHeaderHeight" mwlDroppable (dragEnter)="dragEnter('time')" (dragLeave)="dragLeave('time')">
        @if (view.hourColumns.length > 0) {
        <div class="cal-time-label-column">
            @for (hour of view.hourColumns[0].hours; track hour.segments[0].date.toISOString(); let odd = $odd) {
            <div class="cal-hour" [class.cal-hour-odd]="odd">
                @for (segment of hour.segments; track segment.date.toISOString()) {
                <mwl-calendar-week-view-hour-segment [style.height.px]="hourSegmentHeight" [segment]="segment" [segmentHeight]="hourSegmentHeight"
                                                     [locale]="locale" [customTemplate]="hourSegmentTemplate" [isTimeLabel]="true">
                </mwl-calendar-week-view-hour-segment>
                }
            </div>
            }
        </div>
        }
        <div class="cal-day-columns" [class.cal-resize-active]="timeEventResizes.size > 0" #dayColumns>
            @for (column of view.hourColumns; track column.hours[0]
          ? column.hours[0].segments[0].date.toISOString()
          : column) {
            <div class="cal-day-column">
                <mwl-calendar-week-view-current-time-marker [columnDate]="column.date" [dayStartHour]="dayStartHour" [dayStartMinute]="dayStartMinute"
                                                            [dayEndHour]="dayEndHour" [dayEndMinute]="dayEndMinute" [hourSegments]="hourSegments" [hourSegmentHeight]="hourSegmentHeight"
                                                            [customTemplate]="currentTimeMarkerTemplate">
                </mwl-calendar-week-view-current-time-marker>
                @for (timeEvent of column.events; track timeEvent.event.id ?? timeEvent.event) {
                <div #event class="cal-event-container" [class.cal-draggable]="timeEvent.event.draggable && timeEventResizes.size === 0"
                     [class.cal-starts-within-day]="!timeEvent.startsBeforeDay" [class.cal-ends-within-day]="!timeEvent.endsAfterDay"
                     [ngClass]="timeEvent.event.cssClass" [hidden]="timeEvent.height === 0 && timeEvent.width === 0" [style.top.px]="timeEvent.top"
                     [style.height.px]="timeEvent.height" [style.left.%]="timeEvent.left" [style.width.%]="timeEvent.width" mwlResizable [resizeSnapGrid]="{
left: dayColumnWidth,
    right: dayColumnWidth,
        top: eventSnapSize || hourSegmentHeight,
            bottom: eventSnapSize || hourSegmentHeight
          }" [validateResize]="validateResize" [allowNegativeResizes]="true" (resizeStart)="timeEventResizeStarted(dayColumns, timeEvent, $event)"
                     (resizing)="timeEventResizing(timeEvent, $event)" (resizeEnd)="timeEventResizeEnded(timeEvent)" mwlDraggable
                     dragActiveClass="cal-drag-active" [dropData]="{ event: timeEvent.event, calendarId: calendarId }"
                     [dragAxis]="{x: (timeEvent.event.draggable && timeEventResizes.size === 0 ) ?? false, y: (timeEvent.event.draggable && timeEventResizes.size === 0) ?? false}"
                     [dragSnapGrid]="snapDraggedEvents? { x: dayColumnWidth, y: eventSnapSize || hourSegmentHeight }: {}" [ghostDragEnabled]="!snapDraggedEvents"
                     [validateDrag]="validateDrag" (dragStart)="dragStarted(dayColumns, event, timeEvent, true)" (dragging)="dragMove(timeEvent, $event)"
                     (dragEnd)="dragEnded(timeEvent, $event, dayColumnWidth, true)">
                    @if (timeEvent.event?.resizable?.beforeStart &&!timeEvent.startsBeforeDay) {
                    <div class="cal-resize-handle cal-resize-handle-before-start" mwlResizeHandle [resizeEdges]="{left: true,top: true}">
                    </div>
                    }
                    <!-- [customTemplate]="eventTemplate" -->
                    <mwl-calendar-week-view-event [locale]="locale" [weekEvent]="timeEvent" [tooltipPlacement]="tooltipPlacement"
                                                  [tooltipTemplate]="tooltipTemplate" [tooltipAppendToBody]="tooltipAppendToBody"
                                                  [tooltipDisabled]="dragActive || timeEventResizes.size > 0" [tooltipDelay]="tooltipDelay" [customTemplate]="newTemplate"
                                                  [eventTitleTemplate]="eventTitleTemplate" [eventActionsTemplate]="eventActionsTemplate" [column]="column"
                                                  (eventClicked)="eventClicked.emit({event: timeEvent.event,sourceEvent: $event.sourceEvent})">
                        {{timeEvent}}
                    </mwl-calendar-week-view-event>
                    @if (timeEvent.event?.resizable?.afterEnd && !timeEvent.endsAfterDay) {
                    <div class="cal-resize-handle cal-resize-handle-after-end" mwlResizeHandle [resizeEdges]="{right: true,bottom: true}">
                    </div>
                    }
                </div>
                }
                @for (hour of column.hours; track hour.segments[0].date.toISOString(); let odd = $odd) {
                <div class="cal-hour" [class.cal-hour-odd]="odd">
                    @for (segment of hour.segments; track segment.date.toISOString()) {
                    <mwl-calendar-week-view-hour-segment [style.height.px]="hourSegmentHeight" [segment]="segment" [segmentHeight]="hourSegmentHeight"
                                                         [locale]="locale" [customTemplate]="hourSegmentTemplate" (mwlClick)="hourSegmentClicked.emit({date: segment.date,sourceEvent: $event})"
                                                         [clickListenerDisabled]="hourSegmentClicked.observers.length === 0" mwlDroppable
                                                         [dragOverClass]="!dragActive || !snapDraggedEvents ? 'cal-drag-over' : ''" dragActiveClass="cal-drag-active"
                                                         (drop)="eventDropped($event, segment.date, false)">
                    </mwl-calendar-week-view-hour-segment>
                    }
                </div>
                }
            </div>
            }
        </div>
    </div>
</div>

<ng-template #newTemplate let-weekEvent="weekEvent" let-tooltipPlacement="tooltipPlacement" let-eventClicked="eventClicked"
             let-tooltipTemplate="tooltipTemplate" let-tooltipAppendToBody="tooltipAppendToBody" let-tooltipDisabled="tooltipDisabled" let-tooltipDelay="tooltipDelay"
             let-column="column" let-daysInWeek="daysInWeek">
    <!-- [mwlCalendarTooltip]="!tooltipDisabled ? (weekEvent.event.title | calendarEventTitle : (daysInWeek === 1 ? 'dayTooltip' : 'weekTooltip') : weekEvent.tempEvent || weekEvent.event): ''"
  [tooltipPlacement]="tooltipPlacement"
  [tooltipEvent]="weekEvent.tempEvent || weekEvent.event"
  [tooltipTemplate]="tooltipTemplate"
  [tooltipAppendToBody]="tooltipAppendToBody"
  [tooltipDelay]="tooltipDelay" -->
    <div class="cal-event" [ngStyle]="{
          color: $safeNavigationMigration(weekEvent.event.color?.secondaryText),
          backgroundColor: $safeNavigationMigration(weekEvent.event.color?.secondary),
                    borderColor: weekEvent.event.meta?.intervention?.DisponibiliteClient != null ? 'red' : $safeNavigationMigration(weekEvent.event.color?.primary),
                    borderWidth: weekEvent.event.meta?.intervention?.DisponibiliteClient != null ? '3px' : null,
        }" style="line-height: 20px" (mwlClick)="eventClicked.emit({ sourceEvent: $event })" (mwlKeydownEnter)="eventClicked.emit({ sourceEvent: $event })"
         tabindex="0" role="application" [attr.aria-label]="
          { event: weekEvent.tempEvent || weekEvent.event, locale: locale }
            | calendarA11y : 'eventDescription'
        ">
        <div class="row align-items-center">
            <div class="col-2 ">
                @if (weekEvent.event.meta?.intervention?.Status === 3) {
                <span>
                    @if (weekEvent.event.meta?.intervention.ElimsJob.Status === EElimsAggregatedStatus.AllJobsCompleted) {
                    <mat-icon style="height: 20px; width: 20px; font-size: 20px; color: green; vertical-align: bottom;"
                              class="material-symbols-outlined fw-bold">check_circle
                    </mat-icon>
                    } @else if (weekEvent.event.meta?.intervention.ElimsJob.IsPending) {
                    <div class="col-auto">
                        <mat-icon class="material-symbols-outlined">hourglass_empty</mat-icon>
                        <div></div>
                    </div>
                    }@else if (weekEvent.event.meta?.intervention.ElimsJob.HasError) {
                    <mat-icon style="height: 20px; width: 20px; font-size: 20px;  vertical-align: bottom;" color="warn"
                              class="material-symbols-outlined">cancel</mat-icon>
                    }
                </span>
                }
                @if (weekEvent.event.meta?.intervention?.Rush) {
                <span>
                    <mat-icon style="height: 20px; width: 20px; font-size: 20px; color: violet; vertical-align: bottom;"
                              class="material-symbols-outlined fw-bold">rocket_launch
                    </mat-icon>
                </span>
                }
            </div>
            <div [class.col-10]="weekEvent.event.meta?.intervention?.Status === 3 || weekEvent.event.meta?.intervention?.Rush"
                 [class.col-12]="weekEvent.event.meta?.intervention?.Status !== 3 && !weekEvent.event.meta?.intervention?.Rush">

                <mwl-calendar-event-actions [event]="weekEvent.tempEvent || weekEvent.event" [customTemplate]="eventActionsTemplate">
                </mwl-calendar-event-actions>
                &ngsp;
                <mwl-calendar-event-title [event]="weekEvent.tempEvent || weekEvent.event" [customTemplate]="eventTitleTemplate"
                                          [view]="daysInWeek === 1 ? 'day' : 'week'">
                </mwl-calendar-event-title>

            </div>
        </div>
        <div class="row g-0">

            @if (weekEvent.event.meta?.event?.Type === 1) {
            <div class="col fw-bold" style="font-size: 10px;">
                <div class="row g-0">

                    @if (weekEvent.event.meta?.intervention.MesuresOPPose) {
                    <div class="col-auto py-0 px-2 border rounded-1 fw-bold text-center" style="background-color: chartreuse;">
                        {{weekEvent.event.meta?.intervention.MesuresOPPose}} OP
                    </div>
                    }
                    @if (weekEvent.event.meta?.intervention.MesuresAVTPose || weekEvent.event.meta?.intervention.MesuresAPTPose ||
                    weekEvent.event.meta?.intervention.MesuresPDTPose) {
                    <div class="col-auto px-2 border rounded-1 fw-bold text-center" style="background-color: cadetblue; color: white;">
                        @if (weekEvent.event.meta?.intervention.MesuresAVTPose) {
                        <span>
                            {{weekEvent.event.meta?.intervention.MesuresAVTPose}} AVT
                        </span>
                        }
                        @if (weekEvent.event.meta?.intervention.MesuresAPTPose) {
                        <span>
                            {{weekEvent.event.meta?.intervention.MesuresAPTPose}} APT
                        </span>
                        }
                        @if (weekEvent.event.meta?.intervention.MesuresPDTPose) {
                        <span>
                            {{weekEvent.event.meta?.intervention.MesuresPDTPose}} PDT
                        </span>
                        }
                    </div>
                    }
                    @if (weekEvent.event.meta?.intervention.MesuresAVTDepose || weekEvent.event.meta?.intervention.MesuresPDTDepose ||
                    weekEvent.event.meta?.intervention.MesuresAPTDepose) {
                    <div class="col-auto px-2 border rounded-1 fw-bold text-center" style="background-color: slateblue; color: white;">
                        @if (weekEvent.event.meta?.intervention.MesuresAVTDepose) {
                        <span>
                            {{weekEvent.event.meta?.intervention.MesuresAVTDepose}} AVT
                        </span>
                        }
                        @if (weekEvent.event.meta?.intervention.MesuresPDTDepose) {
                        <span>
                            {{weekEvent.event.meta?.intervention.MesuresPDTDepose}} PDT
                        </span>
                        }
                        @if (weekEvent.event.meta?.intervention.MesuresAPTDepose) {
                        <span>
                            {{weekEvent.event.meta?.intervention.MesuresAPTDepose}} APT
                        </span>
                        }
                    </div>
                    }
                    
                    @if (weekEvent.event.meta?.intervention.MesureLingetteList?.length > 0) {
                    <div class="col-auto py-0 px-2 border rounded-1 fw-bold text-center" style="background-color: mediumpurple; color: white;">
                        {{weekEvent.event.meta?.intervention.MesureLingetteList?.length}} {{weekEvent.event.meta?.intervention.MesureLingetteList?.length > 1 ? 'Lingettes' : 'Lingette'}}
                    </div>
                    }
                    @if (weekEvent.event.meta?.intervention.MesureMassifList?.length > 0) {
                    <div class="col-auto py-0 px-2 border rounded-1 fw-bold text-center" style="background-color: tomato; color: white;">
                        {{weekEvent.event.meta?.intervention.MesureMassifList?.length}} {{weekEvent.event.meta?.intervention.MesureMassifList?.length > 1 ? 'Massifs' : 'Massif'}}
                    </div>
                    }
                    @if (weekEvent.event.meta?.intervention.MesureEauList?.length > 0) {
                    <div class="col-auto py-0 px-2 border rounded-1 fw-bold text-center" style="background-color: aqua; ">
                        {{weekEvent.event.meta?.intervention.MesureEauList?.length}} {{weekEvent.event.meta?.intervention.MesureEauList?.length > 1 ? 'Eaux' : 'Eau'}}
                    </div>
                    }
                    @if (weekEvent.event.meta?.intervention.MesureAdductionAirList?.length > 0) {
                    <div class="col-auto py-0 px-2 border rounded-1 fw-bold text-center" style="background-color: darkolivegreen; color: white;">
                        {{weekEvent.event.meta?.intervention.MesureAdductionAirList?.length}} {{weekEvent.event.meta?.intervention.MesureAdductionAirList?.length > 1 ? 'Adductions Air' : 'Adduction Air'}}
                    </div>
                    }
                </div>
            </div>
            }
            @if (weekEvent.event.meta?.event?.Type === 2) {
            <div class="col-12 g-0" [mwlCalendarTooltip]="weekEvent.event.meta.event.Description" [tooltipPlacement]="tooltipPlacement"
                 [tooltipEvent]="weekEvent.tempEvent || weekEvent.event" [tooltipTemplate]="tooltipTemplate" [tooltipAppendToBody]="tooltipAppendToBody"
                 [tooltipDelay]="tooltipDelay">
                <div class="row">
                    <div class="col-12 text-truncate">
                        {{weekEvent.event.meta.event.Description}}
                    </div>
                </div>
            </div>
            }

            @if (weekEvent.event.meta?.event?.Type === 3) {
            <div class="col-12 g-0" [mwlCalendarTooltip]="weekEvent.event.meta.event.Description" [tooltipPlacement]="tooltipPlacement"
                 [tooltipEvent]="weekEvent.tempEvent || weekEvent.event" [tooltipTemplate]="tooltipTemplate" [tooltipAppendToBody]="tooltipAppendToBody"
                 [tooltipDelay]="tooltipDelay">
                <div class="row">
                    <div class="col-12 text-truncate">
                        {{weekEvent.event.meta.event.Description}}
                    </div>
                </div>
            </div>
            }

            @if (weekEvent.event.meta?.event?.Type === 2) {
            <div class="col">
                <mat-icon class="material-symbols-outlined">restaurant</mat-icon>
            </div>
            }
            @if (weekEvent.event.meta?.event?.Type === 3) {
            <div class="col">
                <mat-icon class="material-symbols-outlined">school</mat-icon>
            </div>
            }
            @if (IsDispatch) {
            <div class="col-auto">
                <button class="col-auto small-icon-button" mat-icon-button (click)="onDeleteClicked($event, weekEvent.event)">
                    <mat-icon color="warn" class="material-symbols-outlined">delete</mat-icon>
                </button>
            </div>
            }
        </div>
        @if (weekEvent.event.meta?.event?.Type === 1) {
        <div class="row" class="fw-bold">
            {{weekEvent.event.meta.intervention.Code}}
        </div>
        }

    </div>
</ng-template>